import {
  SET_ACTIVE_FLEET
} from '../actions';
import {
  PROJECTS_UPDATE_FLEET_TEMPLATE_ALERT_CONFIG
} from '../actions/project-actions';

const initialState = {
};

export default function (state = initialState, action) {

  switch(action.type) {
    case SET_ACTIVE_FLEET:
      return action.payload;

    case PROJECTS_UPDATE_FLEET_TEMPLATE_ALERT_CONFIG:
      // If the active fleet contains the template being updated, we need to update it here too
      if (state.asset_templates) {
        const { asset_template_id, alert_configuration_id } = action.payload;
        const templateIndex = state.asset_templates.findIndex(t => t.id === asset_template_id);
        
        if (templateIndex > -1) {
          // Create a deep copy of the state to ensure immutability
          const newState = JSON.parse(JSON.stringify(state));
          newState.asset_templates[templateIndex].alert_configuration_id = alert_configuration_id;
          return newState;
        }
      }
      return state;

    default:
      return state;
  }
}